module.exports = __webpack_public_path__ + "assets/img/title-528d195a.png";